<template>
  <a-modal v-model="modal" title="批量修改叫料标识" width="500px" :maskClosable="false" :closable="true">
    <div>
      <a-radio-group v-model="callFlag">
        <a-radio :style="radioStyle" :value="'Y'">叫料</a-radio>
        <a-radio :style="radioStyle" :value="'N'">不叫料</a-radio>
      </a-radio-group>
    </div>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="modal=false">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { apiBatchUpdateCallFlag } from '@/api/scp/work-order-material/work-order-material'

export default {
  name: 'BatchEditModal',
  data() {
    return {
      fieldType: '', // 修改字段标识
      modal: false,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      callFlag: 'Y',
      loading: false,
      selectedRows: []
    }
  },
  methods: {
    show (list) {
      this.selectedRows = list
      this.callFlag = 'Y'
      this.modal = true
    },
    // 提交
    submit () {
      const ids = this.selectedRows.map(item => item.id)
      const params = { ids: ids, callFlag: this.callFlag }
      this.loading = true;
      apiBatchUpdateCallFlag(params).then(response => {
        if (response.code === 200) {
          this.modal = false
          this.$message.success('修改完成')
          this.$emit("successFun")
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
